import * as React from "react";
import { forwardRef } from "react";
const SvgIcMenuBurger = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", stroke: "#2A2B30", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 12H16M4 6H20M4 18H20", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgIcMenuBurger);
export { ForwardRef as ReactComponent };
